import { memo, useCallback } from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import { makeStyles } from '@material-ui/core';
import TextBoxWithTooltip from '../textBoxWithTooltip';

const useStyles = makeStyles(({ palette: { primary }, spacing }) => ({
  root: {
    boxSizing: 'border-box',
    backgroundColor: ({ color }) => (!color ? primary.bluish8 : color),
    display: 'flex',
    alignItems: 'center',
    padding: spacing(0, 2),
    height: 28,
    transition: 'background-color .25s ease',
    maxWidth: '100%',
    minWidth: 0,
    width: 'auto',
  },
  selectableJob: {
    cursor: 'pointer',
  },
  job: {
    lineHeight: '20px',
    justifySelf: 'start',
    maxWidth: '100%',
  },
}));

const JobChip = ({
  customClass = null,
  jobNameClass = undefined,
  style = null,
  jobNumber = 0,
  item = {},
  isSelectable = false,
  onSelect,
}) => {
  const { color } = item;
  const classes = useStyles({ color });

  const handleSelect = useCallback(
    e => {
      e.preventDefault();
      if (isSelectable) {
        onSelect(item);
      }
    },
    [item, isSelectable, onSelect]
  );

  return (
    <div
      className={classNames(
        classes.root,
        {
          [classes.selectableJob]: isSelectable,
        },
        customClass
      )}
      {...(style ? { style } : {})}
      onClick={handleSelect}
    >
      <TextBoxWithTooltip
        variant="subtitle2"
        className={classNames(classes.job, jobNameClass)}
        text={item.name}
        itemNumber={jobNumber}
        isClickable
      />
    </div>
  );
};

JobChip.propTypes = {
  jobNameClass: PropTypes.string,
  style: PropTypes.object,
  customClass: PropTypes.string,
  item: PropTypes.object,
  isSelectable: PropTypes.bool,
  jobNumber: PropTypes.number,
};

export default memo(JobChip);
